import { getIntl } from "./intl.web";
import buildErrorify from "@gethere/common/utils/buildErrorify";

const errorify = buildErrorify(getIntl);

export default errorify;
